import { TypeEnum } from "../../shared/widgets/Form/enums/TypeEnum";
import { IForm } from "../../shared/widgets/Form/models/Form.model";

export const GuardrailsForm: IForm[] = [
  {
    label: "Type",
    field: "type",
    value: "keyword",
    options: [
      { label: "Keyword", value: "keyword" },
      { label: "RegexPattern", value: "regexPattern" },
    ],
    type: TypeEnum.Dropdown,
  },
  {
    label: "Pattern",
    field: "pattern",
    value: "",
    type: TypeEnum.Input,
  },
  {
    label: "Value",
    field: "value",
    value: "",
    type: TypeEnum.Input,
  },
];
